import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { AppError, MessageScopeType, MessageService, MessageType } from "@obg/ngx.core";
import { merge, of } from "rxjs";
import { catchError, filter, map, switchMap } from "rxjs/operators";

import { DATA_PROTECTION_ACTION_TYPE, DataProtectionAction } from "./data-protection.action";
import { DataProtectionConfigService } from "./data-protection.config";
import { DATA_PROTECTION_MESSAGE_CONTEXT } from "./data-protection.const";
import { DataProtectionService } from "./data-protection.service";

@Injectable()
export class DataProtectionEffect {
	getGdprEnabledCountries$ = createEffect(() =>
		this.actions$.pipe(
			ofType(DATA_PROTECTION_ACTION_TYPE.getGdprEnabledCountries),
			filter(() => !this.config.getCookieConsentDisabled() || !this.config.getMarketingConsentDisabled()),
			switchMap(() =>
				this.service.getGdprEnabledCountries().pipe(
					map((response) => this.action.getGdprEnabledCountriesSuccess(response)),
					catchError((error: AppError) => of(this.action.getGdprEnabledCountriesFail(error)))
				)
			)
		)
	);

	initMessages$ = createEffect(() =>
		merge(
			this.messageService.mapErrorByContext$(
				{
					[DATA_PROTECTION_ACTION_TYPE.getGdprEnabledCountriesFail]:
						DATA_PROTECTION_MESSAGE_CONTEXT.getGdprEnabledCountries,
				},
				MessageScopeType.Global,
				MessageType.Error
			),
			this.messageService.mapClearByContext$({
				[DATA_PROTECTION_MESSAGE_CONTEXT.getGdprEnabledCountries]:
					DATA_PROTECTION_MESSAGE_CONTEXT.getGdprEnabledCountries,
			})
		)
	);

	constructor(
		private actions$: Actions,
		private service: DataProtectionService,
		private action: DataProtectionAction,
		private messageService: MessageService,
		private config: DataProtectionConfigService
	) {}
}
